const config = {
    // base_url: "http://localhost:8000/api",
    // MEDIA_ROOT_URL: "http://localhost:8000/",
    base_url: "https://api.hisaber.com/api/",
  
  
  };
  export default config;